import { render, staticRenderFns } from "./ManageRotasSlaView.vue?vue&type=template&id=428dfc3e&scoped=true"
import script from "./ManageRotasSlaView.vue?vue&type=script&lang=ts"
export * from "./ManageRotasSlaView.vue?vue&type=script&lang=ts"
import style0 from "./ManageRotasSlaView.vue?vue&type=style&index=0&id=428dfc3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dfc3e",
  null
  
)

export default component.exports